<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Online Styles</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="p-grid">
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">General Site</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.siteBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="siteBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.siteBgColor"
								/>
								<label for="headerBgColor">Site Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.headerBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="headerBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.headerBgColor"
								/>
								<label for="headerBgColor">Header Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.headerTextColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="headerTextColor"
									[(ngModel)]="venueSvc.ooVenue.styles.headerTextColor"
								/>
								<label for="headerTextColor">HeaderText</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Navigation & Canvas Selection</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuGroupSelectedColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="siteBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuGroupSelectedColor"
								/>
								<label for="headerBgColor">Selected Canvas Option</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuGroupDeselectedColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="headerBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuGroupDeselectedColor"
								/>
								<label for="headerBgColor">Unselected Canvas Option</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Order Cart</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.cartButtonBackgroundColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="headerTextColor"
									[(ngModel)]="venueSvc.ooVenue.styles.cartButtonBackgroundColor"
								/>
								<label for="headerTextColor">Cart Btn Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.cartButtonTextColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="headerTextColor"
									[(ngModel)]="venueSvc.ooVenue.styles.cartButtonTextColor"
								/>
								<label for="headerTextColor">Cart Btn Text</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div class="ms-2">Cart button icon options</div>
					</div>

					<div class="d-flex mt-3">
						<div class="d-flex flex-column w-100 me-2">
							<div class="flex-fill">
								<span class="p-float-label">
									<p-dropdown
										#cartButtonPrefix
										[options]="app.references.fontAwesomePrefixes"
										optionLabel="label"
										optionValue="value"
										name="cartButtonPrefix"
										[(ngModel)]="venueSvc.ooVenue.styles.cartButtonIconPrefix"
										[style]="{ width: '100%' }"
										styleClass="mx-2"
										appendTo="body"
										[autoDisplayFirst]="false"
										[virtualScroll]="true"
										virtualScrollItemSize="30"
										filter="true"
										filterBy="label"
										(onChange)="changesToSave = true"
									></p-dropdown>
									<label for="cartButtonPrefix" class="ms-2">Icon Type</label>
								</span>
							</div>
							<div class="mt-4 flex-fill">
								<span class="p-float-label">
									<p-dropdown
										#cartButtonIcon
										[options]="cartIconOptions"
										optionLabel="label"
										optionValue="value"
										name="cartButtonIcon"
										[(ngModel)]="venueSvc.ooVenue.styles.cartButtonIconName"
										[style]="{ width: '100%' }"
										styleClass="mx-2"
										appendTo="body"
										[autoDisplayFirst]="false"
										[virtualScroll]="true"
										virtualScrollItemSize="30"
										filter="true"
										filterBy="name"
										(onChange)="changesToSave = true"
									></p-dropdown>
									<label for="cartButtonIcon" class="ms-2">Icon</label>
								</span>
							</div>
						</div>
						<div class="ms-4 me-4 my-auto">
							<fa-icon
								[icon]="[
									venueSvc.ooVenue.styles?.cartButtonIconPrefix || 'far',
									venueSvc.ooVenue.styles?.cartButtonIconName || 'shopping-cart'
								]"
								size="lg"
							></fa-icon>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Canvases</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="menuBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuBgColor"
								/>
								<label for="menuBgColor">Canvas Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuItemNameColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="menuItemNameColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemNameColor"
								/>
								<label for="menuItemNameColor">Canvas Names</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuItemDescriptionColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="menuItemDescriptionColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDescriptionColor"
								/>
								<label for="menuItemDescriptionColor">Canvas Descriptions</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.canvasItemCellBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="canvasItemCellBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.canvasItemCellBgColor"
								/>
								<label for="canvasItemCellBgColor">Canvas Item Cell Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.canvasItemBorderColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="canvasItemBorderColor"
									[(ngModel)]="venueSvc.ooVenue.styles.canvasItemBorderColor"
								/>
								<label for="canvasItemBorderColor">Canvas Item Cell Border</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						Canvas Item Image Shadow Box<p-inputSwitch
							[(ngModel)]="venueSvc.ooVenue.styles.menuItemBoxShadow"
							(onChange)="changesToSave = true"
						></p-inputSwitch>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Menu Item View</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="menuItemDetailBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailBgColor"
								/>
								<label for="menuItemDetailBgColor">Item View Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailNameColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="menuItemDetailNameColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailNameColor"
								/>
								<label for="menuItemDetailNameColor">Item Names</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailDescriptionColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="menuItemDetailDescriptionColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailDescriptionColor"
								/>
								<label for="menuItemDetailDescriptionColor">Item Descriptions</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModGroupColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="menuItemDetailModGroupColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModGroupColor"
								/>
								<label for="menuItemDetailModGroupColor">Modifer Groups</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModNameColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="menuItemDetailModNameColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModNameColor"
								/>
								<label for="menuItemDetailModNameColor">Modifer Names</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModDescriptionColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="menuItemDetailModDescriptionColor"
									[(ngModel)]="venueSvc.ooVenue.styles.menuItemDetailModDescriptionColor"
								/>
								<label for="menuItemDetailModDescriptionColor">Modifer Descriptions</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="p-grid">
		<div class="p-md-4 p-col-12" *ngIf="userService.user.role > 4">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Kiosk</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasItemHeaderBgColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="kioskCanvasItemHeaderBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasItemHeaderBgColor"
								/>
								<label for="kioskCanvasItemHeaderBgColor">Canvas Item Header Bkgrnd</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasItemBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="kioskCanvasItemBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasItemBgColor"
								/>
								<label for="kioskCanvasItemBgColor">Canvas Item Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasMenuBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="kioskCanvasMenuBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.kioskCanvasMenuBgColor"
								/>
								<label for="kioskCanvasMenuBgColor">Canvas Menu Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.kioskOrderStatusButtonBgColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="kioskOrderStatusButtonBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.kioskOrderStatusButtonBgColor"
								/>
								<label for="kioskOrderStatusButtonBgColor">Order Cart Button Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker
								(onChange)="changesToSave = true"
								styleClass="mt-2"
								[(ngModel)]="venueSvc.ooVenue.styles.kioskOrderStausButtonValueSeparatorColor"
							>
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									class="mx-2 mb-2"
									id="kioskOrderStausButtonValueSeparatorColor"
									[(ngModel)]="venueSvc.ooVenue.styles.kioskOrderStausButtonValueSeparatorColor"
								/>
								<label for="kioskOrderStausButtonValueSeparatorColor">Order Cart Label Value Separator Color</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Check</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2">
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.checkBgColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="checkBgColor"
									[(ngModel)]="venueSvc.ooVenue.styles.checkBgColor"
								/>
								<label for="checkBgColor">Background</label>
							</span>
						</div>
					</div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.checkItemNameColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="checkItemNameColor"
									[(ngModel)]="venueSvc.ooVenue.styles.checkItemNameColor"
								/>
								<label for="checkItemNameColor">Item Names</label>
							</span>
						</div>
					</div>
					<div></div>
					<div class="d-flex mt-3">
						<div>
							<p-colorPicker (onChange)="changesToSave = true" styleClass="mt-2" [(ngModel)]="venueSvc.ooVenue.styles.checkModNameColor">
							</p-colorPicker>
						</div>
						<div>
							<span class="p-float-label">
								<input
									pInputText
									(change)="changesToSave = true"
									class="mx-2 mb-2"
									id="checkModNameColor"
									[(ngModel)]="venueSvc.ooVenue.styles.checkModNameColor"
								/>
								<label for="checkModNameColor">Modifer Names</label>
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-md-4 p-col-12">
			<div class="p-0 h-100">
				<div class="d-flex">
					<div class="display-10 mx-4 mt-2 mb-1">Order Status</div>
				</div>
				<p-divider></p-divider>
				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderAssemblingInput
							pInputText
							type="text"
							name="statusOrderAssemblingInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderAssembling"
							class="w-100"
						/>
						<label for="statusOrderAssemblingInput">Order Assembling Status Text</label>
					</span>
				</div>
				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderPaymentAuthInput
							pInputText
							type="text"
							name="statusOrderPaymentAuthInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderPaymentAuth"
							class="w-100"
						/>
						<label for="statusOrderPaymentAuthInput">Order Payment Auth Text</label>
					</span>
				</div>

				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderSubmittedInput
							pInputText
							type="text"
							name="statusOrderSubmittedInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderSubmitted"
							class="w-100"
						/>
						<label for="statusOrderSubmittedInput">Order Submitting Status Text</label>
					</span>
				</div>
				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderQueuedInput
							pInputText
							type="text"
							name="statusOrderQueuedInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderQueued"
							class="w-100"
						/>
						<label for="statusOrderQueuedInput">Order Queued Status Text</label>
					</span>
				</div>
				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderSentToPosInput
							pInputText
							type="text"
							name="statusOrderSentToPosInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderSentToPos"
							class="w-100"
						/>
						<label for="statusOrderSentToPosInput">Sending Order to POS Status Text</label>
					</span>
				</div>
				<div class="p-2 mt-3">
					<span class="p-float-label">
						<input
							#statusOrderMobileCheckSaveInput
							pInputText
							type="text"
							name="statusOrderMobileCheckSaveInput"
							[(ngModel)]="venueSvc.ooVenue.styles.statusOrderMobileCheckSave"
							class="w-100"
						/>
						<label for="statusOrderMobileCheckSaveInput">Order Received Successfully Text</label>
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
